import { ImageFragment } from '@/graphql/fragments/image';
import { ResourceBaseFragment } from '@/graphql/fragments/resource';
import { TopicsBaseFragment } from '@/graphql/fragments/topics';
import { gql } from '@apollo/client';

export const QUERY_FETCH_KNOWLEDGE_HUB_PAGE = gql`
  query knowledgeHubPage {
    knowledgeHubPage {
      data {
        attributes {
          topics {
            data {
              attributes {
                ...TopicsBaseFragment
              }
            }
          }
          highlightOfTheWeekTitle
          highlightTopicLabel
          latestTitle
          moreButotnTItle
          chooseAThemeTitle
          welcomePageMessage {
            title
            description
          }
          highlights {
            data {
              attributes {
                ...ResourceBaseFragment
              }
            }
          }
          searchSection {
            title
            searchInput
            whatKindTitle
            chooseATopicTitle
            chooseCollectionTitle
            topics {
              data {
                attributes {
                  topic
                }
              }
            }
            themes {
              data {
                attributes {
                  theme
                }
              }
            }
            types {
              type
            }
          }
          contentTemplateLabels {
            downloadableContentLabel
          }
        }
      }
    }
  }
  ${ResourceBaseFragment}
  ${TopicsBaseFragment}
`;

export const QUERY_FETCH_LATEST_RESOURCES_BY_TOPIC = gql`
  query latestResourcesByTopic($topic: String, $limit: Int, $excludeId: ID) {
    resources(
      filters: { themes: { topic: { topic: { eq: $topic } } }, id: { not: { eq: $excludeId } } }
      pagination: { limit: $limit }
      sort: "publicationDate:desc"
    ) {
      data {
        attributes {
          ...ResourceBaseFragment
        }
      }
    }
  }
  ${ResourceBaseFragment}
`;

export const QUERY_FETCH_LATEST_RESOURCES_BY_THEME = gql`
  query latestResourcesByTheme($theme: String!, $limit: Int, $page: Int) {
    resources(
      filters: { themes: { theme: { eq: $theme } } }
      pagination: { pageSize: $limit, page: $page }
      sort: "publicationDate:desc"
      publicationState: LIVE
    ) {
      data {
        attributes {
          ...ResourceBaseFragment
        }
      }
      meta {
        pagination {
          total
          pageCount
          page
          pageSize
        }
      }
    }
  }
  ${ResourceBaseFragment}
`;

export const QUERY_FETCH_LATEST_RESOURCES_BY_TYPEE = gql`
  query latestResourcesByType($types: [String], $limit: Int, $page: Int) {
    resources(
      filters: { resourceType: { type: { in: $types } } }
      pagination: { pageSize: $limit, page: $page }
      sort: "publicationDate:desc"
    ) {
      data {
        id
        attributes {
          ...ResourceBaseFragment
        }
      }
      meta {
        pagination {
          total
          pageCount
          page
          pageSize
        }
      }
    }
  }
  ${ResourceBaseFragment}
`;

export const QUERY_FETCH_MAIN_LATEST_RESOURCES = gql`
  query fetchMainLatestResources($limit: Int) {
    resources(pagination: { pageSize: $limit }, sort: "publicationDate:desc") {
      data {
        attributes {
          ...ResourceBaseFragment
        }
      }
    }
  }
  ${ResourceBaseFragment}
`;

export const QUERY_FETCH_TRENDING_RESOURCES = gql`
  query fetchTrendingResources($limit: Int!) {
    trendingResources(limit: $limit) {
      attributes {
        createdAt
        publishedAt
        title
        slug
        duration
        resourceType {
          data {
            attributes {
              type
            }
          }
        }
        briefDescription
        themes {
          data {
            attributes {
              theme
              topic {
                data {
                  attributes {
                    topic
                  }
                }
              }
            }
          }
        }
        cover {
          data {
            ...ImageFragment
          }
        }
      }
    }
  }
  ${ImageFragment}
`;

export const QUERY_FETCH_ALL_TIME_FAVOURITE_RESOURCES = gql`
  query fetchTopFavoriteResources($limit: Int!) {
    topFavoriteResources(limit: $limit) {
      attributes {
        createdAt
        publishedAt
        title
        slug
        duration
        resourceType {
          data {
            attributes {
              type
            }
          }
        }
        briefDescription
        themes {
          data {
            attributes {
              theme
              topic {
                data {
                  attributes {
                    topic
                  }
                }
              }
            }
          }
        }
        cover {
          data {
            ...ImageFragment
          }
        }
      }
    }
  }
  ${ImageFragment}
`;
